import { Audience } from "types";
import {
  KnownOrganizationIds,
  ServiceStatus,
  BooleanExpression,
  Recipe,
  RecipeBase
} from "@madhive/mad-sdk";
import { AudienceToCreate } from "./types";

export const getApiAudienceBooleanExpression = (
  expression: BooleanExpression
): BooleanExpression => expression;

export const smithersAudienceToRecipe = (
  audience: AudienceToCreate,
  id: string,
  parent?: KnownOrganizationIds
): RecipeBase => ({
  id,
  name: audience.name.trim().replace(/–|—/g, "-"),
  description: audience.description,
  parent,
  type: audience.type,
  expression: audience.expression,
  status: ServiceStatus.READY,
  preferred: false
});

export const recipeToSmithersAudience = (recipe: Recipe): Audience => {
  return {
    ...recipe,
    label: recipe.name,
    maxPrice: recipe.price?.max ?? 0,
    minPrice: recipe.price?.min ?? 0,
    householdCount: recipe.householdReach,
    preferred: recipe.preferred,
    derivedStatus: recipe.derivedStatus
  };
};
